<mic-spinner-overlay ariaLabel="loading" color="primary" [loading]="isLoading || saveIsLoading">

  <mic-breadcrumb>
    <mic-breadcrumb-link link="/sites" label="{{ 'sites.seasonality.breadcrumbSites' | translate }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/sites/seasonality" label="{{ 'sites.seasonality.breadcrumbSeasonality' | translate }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <!-- Page Header -->
  <h1>{{ 'sites.seasonality.title' | translate }}</h1>
  <p>{{ 'sites.seasonality.description' | translate }}</p>

  <div>
    <mat-card class="card-content">
      <mat-card-content>

        <!-- Header -->
        <div id="tab-content-header">
          <div id="tab-content-header-filler"></div>
          <tkc-modification-buttons class="buttons-header"
            [isModificationsPending]="isModificationsPending && !isProposedOutOfBounds"
            [saveModifications]="saveModifications.bind(this)"
            [resetModifications]="resetModifications.bind(this)">
            <button mat-flat-button color="accent" extra-button (click)="onConfirmSaveAndRecalculate()" [disabled]="!isModificationsPending">
              <mat-icon>save</mat-icon>
              {{ 'sites.seasonality.saveAndRecalculate' | translate }}
            </button>
          </tkc-modification-buttons>
        </div>

        <!-- Size selector -->
        <div id="table-content-size" class="card-side-padding">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'sites.seasonality.size' | translate }}</mat-label><mat-select
            [placeholder]="(sizes?.length ?? 0) > 0 ? ('sites.seasonality.sizeSelect' | translate) : ('sites.seasonality.noSizes' | translate)"
            [formControl]="sizeCtrl"
            multiple
          >
              <mat-select-trigger>
                <ng-container *ngIf="!sizeCtrl.value?.length">
                    {{ 'sites.seasonality.sizeSelect' | translate }}
                </ng-container>
                <ng-container *ngIf="sizeCtrl.value?.length">
                  @if (sizeCtrl.value.length == 1) {
                    {{ 'sites.seasonality.sizeSingularSelected' | translate }}
                  }
                  @else {
                    {{ 'sites.seasonality.sizePluralSelected' | translate:{count: sizeCtrl.value.length} }}
                  }
                </ng-container>
              </mat-select-trigger>
              <mat-option *ngFor="let size of sizes" [value]="size">
                {{ size }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="chip-list" *ngIf="sizeCtrl.value?.length">
            <mat-chip-set>
              <mat-chip
                *ngFor="let size of sizeCtrl.value"
                [removable]="true"
                (removed)="removeSize(size)"
              >
                {{ size }}
                <button matChipRemove>
                  <mat-icon>close</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>

        <!-- TABLE INDEX + PROPOSED -->
        <h2 class="h2-seasonality card-side-padding">{{'sites.seasonality.titleIndexTable' | translate}}</h2>

        <div id="historical_fitment">
          <div class="table-container">

            <table mat-table [dataSource]="dataSourceIndex">

              <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef>{{'sites.seasonality.type' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.type == SEASONALITY_TYPE_CALCULATED_INDEX ) {
                    {{ 'sites.seasonality.calculatedIndex' | translate }}
                  } @else {
                    {{ 'sites.seasonality.proposedIndex' | translate }}
                  }
                </td>
              </ng-container>

              @for (m of [1,2,3,4,5,6,7,8,9,10,11,12]; track m) {
                <ng-container [matColumnDef]="'m' + m">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ monthKeys[m-1] | translate }}
                  </th>

                  <td mat-cell *matCellDef="let row" class="tkc-number">
                    <ng-container *ngIf="row.type === SEASONALITY_TYPE_PROPOSED_INDEX; else readonlyCell">
                      <ng-container *ngIf="sizes?.length > 0 && sizeCtrl.value?.length > 0; else dashCell">
                        <mat-form-field appearance="outline" class="month-input">
                          <input
                            matInput
                            type="number"
                            min="0"
                            max="999"
                            step="1"
                            [formControl]="proposedCtrl.at(m-1)"
                            (blur)="onMonthBlur(m-1)"
                          />
                        </mat-form-field>
                      </ng-container>
                      <ng-template #dashCell>
                        -
                      </ng-template>
                    </ng-container>

                    <ng-template #readonlyCell>
                      {{ row.months[m-1] ?? '-' }}
                    </ng-template>
                  </td>
                </ng-container>
              }

              <ng-container matColumnDef="average">
                <th mat-header-cell *matHeaderCellDef>{{'sites.seasonality.average' | translate}}</th>
                <td mat-cell *matCellDef="let row"
                    [ngClass]="{ 'average-warning': isAverageOutOfRange(row) }" class="tkc-number">
                  <ng-container *ngIf="!(row.type === SEASONALITY_TYPE_PROPOSED_INDEX
                     && (((sizes?.length ?? 0) === 0) || ((sizeCtrl.value?.length ?? 0) === 0)));
                     else dashAvg">
                    {{ row.average | number:'1.0-0' }}
                  </ng-container>
                  <ng-template #dashAvg>-</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>{{'sites.seasonality.action' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                  <button
                    class="button-redo"
                    mat-icon-button
                    color="blue"
                    *ngIf="row.type === SEASONALITY_TYPE_PROPOSED_INDEX && (sizes?.length ?? 0) > 0 && (sizeCtrl.value?.length > 0)"
                    (click)="copyCalculatedToProposed()"
                    [matTooltip]="'sites.seasonality.tooltipProposed' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="icon-redo icon-color">redo</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row [ngClass]="{
                    'animated' : row.type === SEASONALITY_TYPE_CALCULATED_INDEX && shouldAnimate,
                    'row-excluded': row.type === SEASONALITY_TYPE_YEAR && !row.included
                    }"
                  *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <br>

            <h2 class="h2-seasonality card-side-padding">{{'sites.seasonality.titleHistoricalTable' | translate}}</h2>
            <!-- TABLE YEAR + AVERAGE -->
            <table mat-table [dataSource]="dataSourceYear">

              <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef>{{'sites.seasonality.year' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.type === SEASONALITY_TYPE_AVERAGE ) {
                    {{ 'sites.seasonality.average' | translate }}
                  } @else {
                    {{ row.year }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="average">
                <th mat-header-cell *matHeaderCellDef>{{'sites.seasonality.averageQuantity' | translate}}</th>
                <td mat-cell *matCellDef="let row" class="tkc-number">
                  {{ row.average | number:'1.0-0' }}
                </td>
              </ng-container>

              @for (m of [1,2,3,4,5,6,7,8,9,10,11,12]; track m) {
                <ng-container [matColumnDef]="'m' + m">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ monthKeys[m-1] | translate }}
                  </th>
                  <td mat-cell *matCellDef="let row" class="tkc-number">
                    {{ row.months[m-1] ?? '-' }}
                  </td>
                </ng-container>
              }

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>{{'sites.seasonality.action' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                  <button
                    mat-icon-button
                    color="blue"
                    *ngIf="row.type === SEASONALITY_TYPE_YEAR"
                    (click)="toggleRow(row)"
                  >
                    <mat-icon class="icon-color">
                      {{ row.included ? 'visibility' : 'visibility_off' }}
                    </mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row [ngClass]="{
                    'animated' : row.type === SEASONALITY_TYPE_AVERAGE && shouldAnimate,
                    'row-excluded': row.type === SEASONALITY_TYPE_YEAR && !row.included
                    }"
                  *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div>
              <div class="legend card-side-padding card-bottom-padding">
                <mat-icon class="icon-color">
                  {{ 'visibility' }}
                </mat-icon>
                <span> {{'sites.seasonality.legend' | translate}} </span>
              </div>
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  </div>

</mic-spinner-overlay>
